import React, { useContext } from 'react'
import clsx from 'clsx'
import RecordingGroupGridRow from '@Components/MatchComponents/v2/RecordingGroupGridRow'
import { StoresContext } from '@App/contexts'
import { useParams } from 'react-router'
import RecordingGroupCategory from '@App/enum/recording-group-category'
import { observer } from 'mobx-react'
import RecordingGroupGridHeader from '@Components/MatchComponents/v2/RecordingGroupGridHeader'
import { PARAM } from '@App/navigation/param'

interface RecordingGroupGrid {
    foundStatus: RecordingGroupCategory
}

const RecordingGroupGrid = (props: RecordingGroupGrid) => {
    const params = useParams<typeof PARAM>()
    if (!params.submissionId) {
        return <></>
    }
    const { matchHistoryStore } = useContext(StoresContext)
    const { foundStatus } = props
    const foundData = matchHistoryStore.recordingGroupsDetails[foundStatus]
    const isPendingStatus = foundStatus === RecordingGroupCategory.Pending
    const isRejectedStatus = foundStatus === RecordingGroupCategory.Rejected

    const gridClassNames = clsx(
        'recording-group-grid',
        isPendingStatus && 'pending-data',
        isRejectedStatus && 'rejected-data'
    )

    return (
        <div className={gridClassNames}>
            <RecordingGroupGridHeader isPendingStatus={isPendingStatus} isRejectedStatus={isRejectedStatus} />
            {foundData?.content?.map((recordingGroupDetail, idx) => (
                <RecordingGroupGridRow
                    recordingGroup={recordingGroupDetail}
                    key={idx}
                    showValue={isPendingStatus}
                    showRejectedReason={isRejectedStatus}
                />
            ))}
        </div>
    )
}

export default observer(RecordingGroupGrid)
